// src/utils/timeUtils.js
import api from "../api";

export const checkRemainingTestTime = async ({ testId, userId, sessionKey }) => {
  const payload = { test_id: testId, user_id: userId };

  try {
    const request = {
      url: `/v1/examPanel/getTimeleft`,
      method: "POST",
      headers: {
        "X-Device-Key": localStorage.getItem("identityKey"),
        "X-Session-Key": sessionKey,
      },
      data: payload,
    };

    const response = await api.postAuthTZ(request);
    // console.log(response);
    return response.data;

  } catch (error) {
    console.error("⛔ checkRemainingTestTime error:", error);

    // 🔁 Consistent error handling like SaveAndNext
    alert("This session is already expired. This happens if you are trying to login using multiple devices");

    window.location.href = "/";
    window.close(); // attempt to close test window
    throw error; // Optional: propagate if needed
  }
};
